import { render, staticRenderFns } from "./ComponentsTreeItem.vue?vue&type=template&id=99633244&scoped=true&"
import script from "./ComponentsTreeItem.vue?vue&type=script&lang=js&"
export * from "./ComponentsTreeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99633244",
  null
  
)

export default component.exports